import { Country } from '@bigcommerce/checkout-sdk'
import store from '../store'
import { setAddresses, setGlobalIsPending } from '../store/actions'
import { createAddress, AddressInfo } from '../request/apis'
import { storage, constants } from '../utils'

export const addNewB3Address = async ({
  newAddress, // it's from the form to be the shipping address,but not a intact shipping address
  billingSameAsShipping,
  isBillingMode,
  b2bCustomFields,
}: {
  newAddress: any
  billingSameAsShipping?: boolean
  isBillingMode?: boolean,
  b2bCustomFields?: any,
}) => {
  const {
    company: {
      companyBasicInfo: { companyName },
      addresses,
      countries,
    },
  } = store.getState()

  const isShipping = isBillingMode ? 0 : 1
  const isBilling =
    (isBillingMode && Number(isBillingMode)) || Number(billingSameAsShipping)

  const {
    shouldSaveAddress,
    address1: addressLine1,
    address2: addressLine2,
    city,
    company,
    countryCode,
    firstName,
    lastName,
    phone: phoneNumber,
    postalCode: zipCode,
    stateOrProvinceCode: stateCode,
    stateOrProvince, // it will be none when selected a sate instead of input the state,but shipping address will fill it by the state code
    customFields,
  } = newAddress

  // if we have company addresses & newAddress's addressId equal undefined,it's a address selected action
  if (addresses.length && newAddress.addressId === undefined) return

  let extraFields: any = []
  if (b2bCustomFields && JSON.stringify((b2bCustomFields as any)) !== '{}') {
    extraFields = Object.keys(b2bCustomFields).map((item: any) => {
        return {
            fieldName: item,
            fieldValue: b2bCustomFields[item]
        }
    })
  }

  const currentCompanyName = storage.B3FormCompanyName.getValue() || companyName
  const label = company
    .replace(new RegExp(`^([\\s\\S]*)${currentCompanyName}$`), '$1')
    .split('/')[0]
    
  const selectedCountry: Country = countries.find(
    (country: { code: any }) => country.code === countryCode
  )
  const countryName = selectedCountry?.name ?? '' // country name is none,but shipping address's country will be filled by the country code
  const stateName = stateCode
    ? selectedCountry?.subdivisions.find(state => state.code === stateCode)
      ?.name
    : stateOrProvince //same as country name

  let addressId = ''
  if (shouldSaveAddress && (storage.B3AddressBookActionPermission.getValue() === constants.B3AddressBookPermission.isAllow)) {
    store.dispatch(setGlobalIsPending(true))
    try {
      const resp = await createAddress(storage.B3CompanyId.getValue(), {
        addressLine1,
        addressLine2,
        city,
        label,
        country: {
          countryName,
          countryCode,
        },
        firstName,
        lastName,
        phoneNumber,
        state: {
          stateName,
          stateCode,
        },
        zipCode,
        isShipping,
        isBilling,
        extraFields,
      } as AddressInfo)

      addressId = resp.addressId
    } finally {
      store.dispatch(setGlobalIsPending(false))
    }
  }

  const address = {
    ...newAddress,
    id: addressId,
    email: '',
    country: countryName,
    stateOrProvince: stateName,
    addressId,
    label,
    isShipping,
    isBilling,
    customFields: customFields.filter(({fieldValue}: { fieldValue: any }) => fieldValue.fieldId === undefined),
    extraFields,
  }

  if (!addressId) storage.B3CachedAddress.setValue(JSON.stringify(address))

  const newAddresses = [
    ...(addressId
      ? addresses
      : addresses.filter((address: AddressInfo) => address.addressId)),
    address,
  ]

  store.dispatch(setAddresses(newAddresses))
  storage.B3FormCompanyName.removeValue()
}
